import { jsx as r } from "react/jsx-runtime";
function s({ name: e, ...n }) {
  return /* @__PURE__ */ r("svg", { ...n, children: /* @__PURE__ */ r("use", { href: `/sprite.svg#${e}` }) });
}
export {
  s as Icon
};
